import cart from '~/assets/theme/dhf/floating-menu/cart.svg';
import cartActive from '~/assets/theme/dhf/floating-menu/cart-active.svg';
import message from '~/assets/theme/dhf/floating-menu/message.svg';
import messageActive from '~/assets/theme/dhf/floating-menu/message-active.svg';
import line from '~/assets/theme/dhf/floating-menu/line.svg';
import lineActive from '~/assets/theme/dhf/floating-menu/line-active.svg';
import mobile from '~/assets/theme/dhf/floating-menu/mobile.svg';
import mobileActive from '~/assets/theme/dhf/floating-menu/mobile-active.svg';
import service from '~/assets/theme/dhf/floating-menu/service.svg';
import serviceActive from '~/assets/theme/dhf/floating-menu/service-active.svg';
import close from '~/assets/theme/dhf/floating-menu/close.svg';

// The fixed-right-bar-box row has six columns in this order. Only its direct
// ImageItem children opt into these visuals; configured actions stay intact.
export const floatingMenuVisuals = [
  { src: cart, activeSrc: cartActive, labelKey: 'floatingMenu.cart' },
  { src: message, activeSrc: messageActive, labelKey: 'floatingMenu.message' },
  { src: line, activeSrc: lineActive, labelKey: 'floatingMenu.line' },
  { src: mobile, activeSrc: mobileActive, labelKey: 'floatingMenu.app' },
  { src: service, activeSrc: serviceActive, labelKey: 'floatingMenu.service' },
  { src: close, labelKey: 'floatingMenu.collapse', hideLabel: true, size: 20 },
];
